import React, { useEffect } from "react";
import { Stack, Box } from "@mui/material";
import Typography from "@mui/material/Typography";
import { useTheme } from "@mui/material/styles";
import LinkText from "components/LinkText";

const footerURL = {
  privacy: "https://login.nuclias.com/#/privacy_?p=u",
  terms: "https://login.nuclias.com/#/terms_?p=u",
};

export default function Footer() {
  const theme = useTheme();
  const fontColor = theme.palette.primary.greyPrimary;

  // Get current year from system time
  const currentYear = new Date().getFullYear();

  const openTab = (type) => {
    const url = type === "privacy" ? footerURL.privacy : footerURL.terms;
    window.open(url, "_blank", "noopener,noreferrer");
  };

  const renderTrustarc = () => {
    const trustarcDom = document.querySelector("#teconsent");
    const trustarcBlackbar = document.querySelector("#consent_blackbar");
    trustarcDom.innerHTML = "";
    trustarcBlackbar.innerHTML = "";

    const langCode = "en"; // Hardcoded to 'en' for now
    const trustarcUrl = `//consent.trustarc.com/notice?domain=mydlink.com&c=teconsent&js=nj&noticeType=bb&text=true&language=${langCode}&gtm=1`;
    const bodyDom = document.querySelector("body");
    const scriptDom = document.createElement("script");

    scriptDom.setAttribute("async", "async");
    scriptDom.setAttribute("src", trustarcUrl);
    scriptDom.setAttribute("crossorigin", "anonymous");
    bodyDom.appendChild(scriptDom);
  };

  useEffect(() => {
    renderTrustarc();
  }, []);

  return (
    <>
      <Stack
        direction='column'
        alignItems='center'
        sx={{ p: "24px 16px 0px", mt: "auto" }}
      >
        <Typography
          variant='caption'
          style={{
            color: fontColor,
            textAlign: "center",
            fontSize: theme.typography.customFontSize[1],
          }}
        >
          D-Link is a registered trademark of D-Link Corporation and its
          overseas subsidiaries. <br />
          All other trademarks belong to their respective owners.©{
            currentYear
          }{" "}
          D-Link Corporation. All rights reserved.
        </Typography>

        <Typography
          variant='caption'
          style={{
            color: fontColor,
            textAlign: "center",
            fontSize: theme.typography.customFontSize[3],
          }}
        >
          <Box display={"flex"} justifyContent='center' gap={0.5}>
            <LinkText>
              <Box onClick={() => openTab("terms")}>Terms</Box>
            </LinkText>
            ⏐
            <LinkText>
              <Box onClick={() => openTab("privacy")}>Privacy</Box>
            </LinkText>
            ⏐
            <LinkText>
              <Box id='teconsent' className='trustarc-link'>
                Cookie Preferences
              </Box>
            </LinkText>
          </Box>
        </Typography>
      </Stack>

      <Box
        id='consent_blackbar'
        className='trustarc-blackbar'
        style={{
          position: "fixed",
          left: "0",
          right: "0",
          bottom: "0",
          width: "100%",
          zIndex: "9999",
        }}
      />
    </>
  );
}
